import type { StorageAdapter } from './StorageAdapter';
import type { StorageRecordKey } from './storageKeys';
import { toStorageStringKey } from './storageKeys';

export class LocalStorageAdapter implements StorageAdapter {
  constructor(private readonly storage: Storage = window.localStorage) {}

  async get(recordKey: StorageRecordKey): Promise<string | null> {
    try {
      return this.storage.getItem(toStorageStringKey(recordKey));
    } catch {
      return null;
    }
  }

  async set(recordKey: StorageRecordKey, value: string): Promise<void> {
    try {
      this.storage.setItem(toStorageStringKey(recordKey), value);
    } catch (e) {
      const message = e instanceof Error ? e.message : String(e);
      throw new Error(`LocalStorageAdapter.set failed: ${message}`);
    }
  }

  async remove(recordKey: StorageRecordKey): Promise<void> {
    try {
      this.storage.removeItem(toStorageStringKey(recordKey));
    } catch {
      // ignore
    }
  }
}
